import { IOffer } from '../../../types/offer';

export function isElectronicTradingAuction(offer: IOffer): boolean {
  return Boolean(offer.tradingLink);
}
